<template>
  <div>
    <v-container fluid class="my-0 py-0">
      <v-card class="mt-3" :elevation="8">
        <Layout
          :rotta_back="rotta_back"
        />
      </v-card>
    </v-container>
  </div>
</template>
<script>
import Layout from "@/views/LAYOUT/layout.vue";

export default {
  name: "LayoutEcogreenAdapter",
  props: [],
  components: {
    Layout,
  },
  data() {
    return {
      // Variabili d'appoggio
        rotta_back: '/home/quicklogistic',
      // Modal

      // Array
    };
  },
  watch: {},
  methods: {},
  mounted() {},
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>